<div class="searchable" [ngClass]="{'has-label': !!label}">
  <form-input [placeholder]="placeholder" [label]="label" cssClass="is-email" [(ngModel)]="value" (keyup.enter)="onEnter($event)"
              [isInvalid]="!this.isValid" [invalidFeedback]="invalidFeedback" [disabled]="disabled"></form-input>
  <fa-icon [icon]="faCircleNotch" [spin]="true" class="searchable-loading" *ngIf="loading"></fa-icon>
</div>
